import { useState, useEffect } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import LightingSection from "../components/LightingSection";
import ReviewsSection from "../components/ReviewsSection";
import WhyChooseSection from "../components/WhyChooseSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const LandingPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]">
      <Header />
      <main>
        <HeroSection isLoaded={isLoaded} />
        <AboutSection />
        <ServicesSection />
        <LightingSection />
        <ReviewsSection />
        <WhyChooseSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
